import { override } from 'flarum/common/extend';

export default () => {
    const { Draft } = flarum.extensions['fof-drafts'].models;

    override(Draft.prototype, 'scheduledValidationError', function(original) {
        // if this is a reply skip the check
        if(this.loadedRelationships?.discussion) {
            return original();
        }
        const chosenTags = this.loadedRelationships?.tags || [];
        const chosenPrimaryTags = chosenTags.filter((tag) => tag.position() !== null && !tag.isChild());
        const chosenSecondaryTags = chosenTags.filter((tag) => tag.position() === null);

        const minPrimaryTags = parseInt(app.forum.attribute('minPrimaryTags'));
        const minSecondaryTags = parseInt(app.forum.attribute('minSecondaryTags'));
        const maxPrimaryTags = parseInt(app.forum.attribute('maxPrimaryTags'));
        const maxSecondaryTags = parseInt(app.forum.attribute('maxSecondaryTags'));

        if (chosenPrimaryTags.length < minPrimaryTags) {
            return `Must set at least ${minPrimaryTags} primary tags`;
        } else if (chosenPrimaryTags.length > maxPrimaryTags) {
            return `Cannot set more than ${maxPrimaryTags} primary tags`;
        } else if (chosenSecondaryTags.length < minSecondaryTags) {
            return `Must set at least ${minPrimaryTags} secondary tags`;
        } else if (chosenSecondaryTags.length > maxSecondaryTags) {
            return `Cannot set more than ${maxPrimaryTags} secondary tags`;
        }
        return original();
    });
};
